import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import PersonIcon from '@mui/icons-material/Person';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import parseMarkdown from '../helpers/parseMarkdown';
import isPersistedChatMessageAdminApi from '../helpers/isPersistedChatMessageAdminApi';
import ErrorDialog from './ErrorDialog';
var Message = function (_a) {
    var message = _a.message;
    var _b = useState(Array.isArray(message.content) ? message.content.length - 1 : 0), contentIndex = _b[0], setContentIndex = _b[1];
    var _c = useState(), errorMessage = _c[0], setErrorMessage = _c[1];
    var isDesktop = useMediaQuery('(min-width:768px)');
    var theme = useTheme();
    var getContent = function () { return (Array.isArray(message.content) ? message.content[contentIndex] : message.content); };
    var handleCopyClick = function () {
        var _a;
        if (message.content) {
            (_a = navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText(getContent()).catch(function (err) {
                // eslint-disable-next-line no-console
                console.error(err);
                setErrorMessage("There's been an error copying to the clipboard");
            });
        }
    };
    var handlePaginateLeftClick = function () { return setContentIndex(contentIndex - 1); };
    var handlePaginateRightClick = function () { return setContentIndex(contentIndex + 1); };
    var handleErrorDialogClose = function () { return setErrorMessage(undefined); };
    var getBgcolor = function () {
        switch (message.role) {
            case 'assistant':
                return theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[100];
            default:
                return theme.palette.mode === 'dark' ? theme.palette.grey[600] : theme.palette.background.default;
        }
    };
    var getIcon = function () {
        switch (message.role) {
            case 'assistant':
                return _jsx(SmartToyIcon, { fontSize: "large" });
            default:
                return _jsx(PersonIcon, { fontSize: "large" });
        }
    };
    return (_jsxs(Box, { bgcolor: getBgcolor(), width: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", pb: 2, pt: 2, children: [_jsx(ErrorDialog, { message: errorMessage, onClose: handleErrorDialogClose }), _jsxs(Box, { width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", children: [Array.isArray(message.content) && message.content.length > 1 && (_jsxs(Box, { children: [_jsx(IconButton, { disabled: contentIndex <= 0, onClick: handlePaginateLeftClick, children: _jsx(ArrowLeftIcon, {}) }), contentIndex + 1, " / ", message.content.length, _jsx(IconButton, { disabled: contentIndex >= message.content.length - 1, onClick: handlePaginateRightClick, children: _jsx(ArrowRightIcon, {}) })] })), _jsxs(Box, { maxWidth: isDesktop && isPersistedChatMessageAdminApi(message) ? '960px' : '768px', width: "90%", display: "flex", flexDirection: "row", alignItems: "flex-start", columnGap: 2, children: [isDesktop && isPersistedChatMessageAdminApi(message) && (_jsx(Card, { sx: { flex: '0 0 auto', width: 175 }, variant: "outlined", children: _jsxs(CardContent, { children: [message.username && (_jsx(Typography, { sx: { fontSize: 12 }, color: "text.secondary", children: message.username })), _jsx(Typography, { sx: { fontSize: 12 }, color: "text.secondary", children: new Date(message.createdAt).toLocaleString() })] }) })), _jsx(Box, { pt: 1, children: getIcon() }), _jsx(Box, { flex: "1 1 auto", minWidth: 0, children: _jsx(Typography, { dangerouslySetInnerHTML: {
                                        __html: parseMarkdown(message.role, getContent())
                                    }, sx: { '& a': { color: theme.palette.primary.main }, overflowWrap: 'break-word' }, color: "text.primary" }) }), _jsx(Box, { pt: 1, pr: 1, children: _jsx(Fab, { size: "small", onClick: handleCopyClick, children: _jsx(ContentCopyIcon, {}) }) })] })] })] }));
};
export default Message;
